// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2e3dR","buttons":"styles_buttons__3hI1u"};